import {get, LOGIN_URL} from "./common";

export const fileDownloadGetUrl = async (location) => {
    try {
        const response = await get(`/file/get-url/${location}`)
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        }
        return response;
    } catch (error) {
        return null;
    }
};